import { atom } from 'recoil';

export const shouldDisplaySquareAd = atom<boolean>({
  default: false,
  key: 'shouldDisplaySquareAd',
});
